import type { UnlinkedDocument } from "./useCmrReportData"

export type ClientFilters = {
  plates?: string
  freeText?: string
  narrowToRoomJid?: string
}

export function applyClientFilters(
  docs: UnlinkedDocument[],
  filters: ClientFilters,
): UnlinkedDocument[] {
  const platesNeedle = filters.plates?.trim().toLowerCase() || undefined
  const textNeedle = filters.freeText?.trim().toLowerCase() || undefined
  const narrow = filters.narrowToRoomJid || undefined

  return docs.filter((doc) => {
    if (narrow && doc.chatJid !== narrow) return false

    if (platesNeedle) {
      const plates = doc.driverContext?.plates?.toLowerCase()
      if (!plates || !plates.includes(platesNeedle)) return false
    }

    if (textNeedle) {
      const data = doc.extractedMetadata?.data
      if (!data) return false
      const hit = Object.values(data).some(
        (v) => typeof v === "string" && v.toLowerCase().includes(textNeedle),
      )
      if (!hit) return false
    }

    return true
  })
}
